import formBaseMixin from '../../../components/form/form-base-mixin.js'
import {wasteGenerators} from '../../../api/api-endpoints.js'
import userFriendlyEr from '../../../utils/userFriendlyEr'

const BILL_TYPE_NAME = 1
const BILL_TYPE_NUMBER = 2

export default {
  mixins: [formBaseMixin],
  data () {
    return {
      loadingOwner: false,
      tabView: 'tab1',
      fields: {
        _bill_type: BILL_TYPE_NAME,
        _owner_id: '',
        _ownerName: '',
        account_ids: [],
        operation_day: '',
        pay_day: '',
        peny: false,
        value: '',
        period: '',
        comment: '',
        saldo: false,
        agent_id: ''
      }
    }
  },
  title () {
    return this.formTitle
  },
  computed: {
    formTitle() {
      return 'Добавление платежа'
    },
    billTypes () {
      return [
        {id: BILL_TYPE_NAME, name: 'По наименованию собственника'},
        {id: BILL_TYPE_NUMBER, name: 'По номеру счету'}
      ]
    },
    BILL_TYPE_NUMBER () {
      return BILL_TYPE_NUMBER
    },
    BILL_TYPE_NAME () {
      return BILL_TYPE_NAME
    },
    collection () {
      return this.$store.getters.readUrlEndpoint(
        this.getCollectionEndpoint()
      ) || {}
    },
    payAgents () {
      return this.collection.pay_agent || []
    },
    ownerBankBooks () {
      return (this.$store.getters.readUrlEndpoint(
        this.ownerBankBooksEndpoint()
      ) || {data: []}).data.map(item => ({
        id: item.id,
        name: `${item.name || item.address}, ЛС №${item.number}`,
        item
      }))
    }
  },
  methods: {
    /**
     * @override
     */
    getSuccessTitle () {
      return null
    },
    resetFieldsOnChangeBillType () {
      this.fields.account_ids = []
      this.fields._owner_id = ''
      this.fields._ownerName = ''
      this.fields.saldo = false
    },
    suggestionLegalsEndpoint (ctx, selected, q) {
      return wasteGenerators.bankBooks({query: {q, 'per-page': 50, type: 'legal'}})
    },
    transformLegalsSuggestions (ctx, data) {
      return data.data.map(item => ({id: item.id, name: `${item.name || item.address}, ИНН ${item.inn || '-'}, ЛС №${item.number}`, item}))
    },
    suggestionOwnerEndpoint (ctx, q) {
      return wasteGenerators.legals({query: {q, 'per-page': 50}})
    },
    transformOwnerSuggestions (ctx, data) {
      return data.data.map(({id, full_name, inn}) => ({id, name: `${full_name}, ИНН ${inn || '-'}`}))
    },
    selectOwnerItem($event) {
      if ($event && $event.id) {
        this.fields._owner_id = $event.id
        this.fields._ownerName = $event.name
        this.fetchOwnerBankBooks()
      } else {
        this.fields._owner_id = ''
        this.fields._ownerName = ''
      }
    },
    async fetchOwnerBankBooks () {
      const endpoint = this.ownerBankBooksEndpoint()
      try {
        this.loadingOwner = true
        await this.$store.dispatch('updateUrlEndpoint', {
          endpoint,
          params: {
            disableGlobalError: true
          }
        })
      } catch (e) {
        // на момент вызова блок еще не создан(v-if)
        // и не отрендерен
        setTimeout(() => {
          this.formValidator.handleServerErrors({
            data: {
              errors: {
                'account_ids': userFriendlyEr.recognize(e, endpoint)
              }
            }
          })
        }, 100)
      } finally {
        this.loadingOwner = false
      }
    },
    ownerBankBooksEndpoint () {
      return wasteGenerators.bankBooksLegals(
        {query: {'per-page': -1}},
        this.fields._owner_id
      )
    }
  },
  asyncData ({store, methods}) {
    return store.dispatch('updateUrlEndpoint', {
      endpoint: methods.getCollectionEndpoint(),
      fromCache: true
    })
  }
}
